var $ =  jQuery;

function init() {
  $('.lock-modal').on('focus','.back-to-close', function() {
    $(this).parent().find('._close-modal').focus();
  });
}

export { init as init };
